import { render, staticRenderFns } from "./IconFileXml.vue?vue&type=template&id=dcdf6c92&scoped=true&"
import script from "./IconFileXml.vue?vue&type=script&lang=js&"
export * from "./IconFileXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf6c92",
  null
  
)

export default component.exports